import { replacePathParams } from '@/api/utils';

export const txCenterApiPaths = {
  list: '/facilityservice/txcenters',
  txCenterById: '/facilityservice/txcenters/:txcenterId',
  txCenterNotes: '/facilityservice/txcenters/:txcenterId/notes',
} as const;

export const getTXCenterApiUrl = {
  list: () => txCenterApiPaths.list,
  txCenterById: (txcenterId: string) => replacePathParams(txCenterApiPaths.txCenterById, { txcenterId }),
  txCenterNotes: (txcenterId: string) => replacePathParams(txCenterApiPaths.txCenterNotes, { txcenterId }),
};
